// Auto-generated - DO NOT EDIT
export const pathMapping = {
  "get:/wello/v2/allows/wello-device-info/message-receive": "messageReceive",
  "put:/wello/v2/allows/wello-device-info/message-receive": "updateMessageReceive",
  "get:/wello/v2/allows/wello-app-push": "welloAppPushList",
  "put:/wello/v2/allows/wello-app-push": "updateWelloAppPushRead",
  "post:/wello/v2/allows/s3": "fileUpload",
  "put:/wello/v2/allows/s3": "updateFileTempSaveYn",
  "delete:/wello/v2/allows/s3": "fileDelete",
  "put:/wello/v2/allows/policy/{metaPolicyIdIdx}/ai": "updatePolicyAiInfo",
  "put:/wello/v2/allows/message-reject/member-wello": "rejectMessage",
  "post:/wello/v2/allows/wello-track": "saveWelloTracking",
  "post:/wello/v2/allows/wello-nonmember-region": "saveWelloNonmemberRegion",
  "post:/wello/v2/allows/wello-device-info": "saveAllowsWelloDeviceInfo",
  "post:/wello/v2/allows/wello-app-push/{welloAppPushReceiverId}": "updateWelloAppPushRead1",
  "post:/wello/v2/allows/wello-app-push/ext": "sendExtAppPush",
  "post:/wello/v2/allows/point-market/product/{productIdIdx}/feedback": "feedbackPointMarketProduct",
  "post:/wello/v2/allows/meta-code/reset": "commonCodeInit",
  "post:/wello/v2/allows/member-oauth/sns/login": "loginWelloSnsMember",
  "post:/wello/v2/allows/member-oauth/before/sns/login": "welloBeforeLogin",
  "post:/wello/v2/allows/log-app-login": "saveLoginResult",
  "post:/wello/v2/allows/local-market/payments/auth-result": "handleAuthResult",
  "post:/wello/v2/allows/kb": "joinEvent",
  "post:/wello/v2/allows/kb-pay/login": "loginWelloWithKbPay",
  "post:/wello/v2/allows/home/gift-product/products": "getGiftProductList",
  "post:/wello/v2/allows/home-love-view": "viewHomeGiftProduct",
  "post:/wello/v2/allows/feed": "findFeeds",
  "post:/wello/v2/allows/external/local-market/payments/webhook": "handleNicePayWebhook",
  "post:/wello/v2/allows/certification/check": "certificationCheck",
  "post:/wello/v2/allows/certification/cellphone": "sendCertificationCellphone",
  "post:/wello/v2/allows/blocklist/reset": "commonCodeInit1",
  "post:/wello/v2/allows/api-counsel": "createApiCounsel",
  "get:/wello/v2/allows/wello-quick-menu": "getWelloQuickMenuList",
  "get:/wello/v2/allows/wello-policy-code": "welloPolicyCodeList",
  "get:/wello/v2/allows/wello-policy-code/reverse-geocoding": "reverseGeocoding",
  "get:/wello/v2/allows/wello-policy-code/kb": "kbWelloPolicyCodeAllList",
  "get:/wello/v2/allows/wello-policy-code/geolocation": "geolocation",
  "get:/wello/v2/allows/wello-policy-code/baby": "welloPolicyCodeBabyList",
  "get:/wello/v2/allows/wello-policy-code/all": "welloPolicyCodeAllList",
  "get:/wello/v2/allows/wello-landing": "detailWelloLanding",
  "get:/wello/v2/allows/wello-comment": "getMetaPolicyCommentList",
  "get:/wello/v2/allows/wello-comment/{welloCommentId}": "getMetaPolicyCommentList1",
  "get:/wello/v2/allows/wello-comment/live": "getLiveWelloCommentList",
  "get:/wello/v2/allows/wello-app-push/count": "newWelloAppPushCnt",
  "get:/wello/v2/allows/welcome-monitor": "getWelcomeMonitorDisplayList",
  "get:/wello/v2/allows/url-mapping/{id}": "getUrlMapping",
  "get:/wello/v2/allows/term/{termCategory}": "term",
  "get:/wello/v2/allows/s3/nonmember-decryption": "fileDecryptionDownload",
  "get:/wello/v2/allows/query/policies": "findPolicies",
  "get:/wello/v2/allows/query/policies/codes/target": "findQueryTargetCode",
  "get:/wello/v2/allows/query/policies/codes/provision": "findQueryProvisionCode",
  "get:/wello/v2/allows/query/policies/codes/job": "findQueryJobCode",
  "get:/wello/v2/allows/query/policies/codes/age": "findQueryAgeCode",
  "get:/wello/v2/allows/query/local-market": "findLocalMarketProducts",
  "get:/wello/v2/allows/query/hometown-news": "findHometownNews",
  "get:/wello/v2/allows/query/gift-products": "findGiftProducts",
  "get:/wello/v2/allows/query/donations-businesses": "findDonationBusinesses",
  "get:/wello/v2/allows/query/best-contents": "findBestContents",
  "get:/wello/v2/allows/policy": "metaPolicyList",
  "get:/wello/v2/allows/policy/{policyId}/community": "getPolicyRelatedCommunityList",
  "get:/wello/v2/allows/policy/{metaPolicyIdIdx}": "metaPolicy",
  "get:/wello/v2/allows/policy/{metaPolicyIdIdx}/related": "getRelatedMetaPolicyList",
  "get:/wello/v2/allows/policy/popular": "popularPolicyList",
  "get:/wello/v2/allows/policy/name-search": "getPolicyListByPolicyName",
  "get:/wello/v2/allows/policy/feedback/{policyId}": "metaPolicyFeedback",
  "get:/wello/v2/allows/policy-dictionary": "getPolicyDictionaryList",
  "get:/wello/v2/allows/policy-code-geocoding": "getPolicyCodeGeocodingList",
  "get:/wello/v2/allows/policy-case/category": "getListPolicyCaseCategory",
  "get:/wello/v2/allows/policy-case/baby": "getListChildcarePolicyBudget",
  "get:/wello/v2/allows/policy-case/baby/related-policy": "getListChildcareRelatedPolicy",
  "get:/wello/v2/allows/policy-apply/home": "getHomeWelloPolicyApplyList",
  "get:/wello/v2/allows/point/info": "getPointInfo",
  "get:/wello/v2/allows/point/earning": "getPointEarning",
  "get:/wello/v2/allows/point/budget": "getPointBudget",
  "get:/wello/v2/allows/point-market/product": "getPointMarketProductList",
  "get:/wello/v2/allows/point-market/product/{productIdIdx}": "getPointMarketProduct",
  "get:/wello/v2/allows/point-market/product/popular": "getPopularPointMarketProductList",
  "get:/wello/v2/allows/point-market/brand": "getPointMarketBrandList",
  "get:/wello/v2/allows/pick": "getWelloPickBannerList",
  "get:/wello/v2/allows/non-member-suggest-policy": "getNonMemberSuggestPolicyList",
  "get:/wello/v2/allows/nice-safe-key/check-plus_success": "checkPlusSuccess",
  "get:/wello/v2/allows/meta-code": "metaCodeAll",
  "get:/wello/v2/allows/member-wello/nickname": "noticeList",
  "get:/wello/v2/allows/member-oauth/sns/refresh-token": "snsRefreshToken",
  "get:/wello/v2/allows/member-oauth/kb-member-login-type": "getKbMemberLoginTypeList",
  "get:/wello/v2/allows/median-income": "getMedianIncomeList",
  "get:/wello/v2/allows/maintenance/check/{id}": "getMaintenance",
  "get:/wello/v2/allows/maintenance/active": "getActiveMaintenanceList",
  "get:/wello/v2/allows/log-term/{termCategory}": "termHistory",
  "get:/wello/v2/allows/local-market/products/{productId}": "getProductDetail",
  "get:/wello/v2/allows/local-market/products/{productId}/seo": "getProductSeoByProductId",
  "get:/wello/v2/allows/local-market/products/{productId}/reviews": "findReviews",
  "get:/wello/v2/allows/local-market/products/{productId}/reviews/{reviewId}": "findReview",
  "get:/wello/v2/allows/local-market/products/{productId}/reviews/photos": "findPhotoReviews",
  "get:/wello/v2/allows/local-market/products/{productId}/inquiries": "findAllInquiries",
  "get:/wello/v2/allows/local-market/products/{productId}/inquiries/{inquiryId}": "findInquiry",
  "get:/wello/v2/allows/local-market/products/by-product-number/{productNumber}": "getProductDetailByProductNumber",
  "get:/wello/v2/allows/local-market/products/by-product-number/{productNumber}/seo": "getProductSeo",
  "get:/wello/v2/allows/local-market/product-feeds": "getProductFeedList",
  "get:/wello/v2/allows/local-market/gift-review-feed/{productId}": "getGiftReviewFeed",
  "get:/wello/v2/allows/local-market/coupons/downloadable": "findGeneralDownloadableCoupons",
  "get:/wello/v2/allows/local-festa/institution-specialty": "getInstitutionSpecialtyList",
  "get:/wello/v2/allows/interest-policy": "allowsInterestPolicyList",
  "get:/wello/v2/allows/hometown-news": "hometownNewsList",
  "get:/wello/v2/allows/hometown-news/{hometownNewsIdIdx}": "hometownNews",
  "get:/wello/v2/allows/hometown-news/{hometownNewsIdIdx}/related": "getRelatedHometownNewsList",
  "get:/wello/v2/allows/hometown-news/popular": "getPopularHometownNewsList",
  "get:/wello/v2/allows/hometown-news/popular/community": "getPopularHometownNewsListForCommunity",
  "get:/wello/v2/allows/hometown-news/feedback/{hometownNewsId}": "hometownNewsFeedback",
  "get:/wello/v2/allows/home/institution/{institutionId}": "getHomeInstitution",
  "get:/wello/v2/allows/home/institution/{homeLoveGovCode}/region": "getHomeInstitutionBenefitRegionList",
  "get:/wello/v2/allows/home/institution/{homeLoveGovCode}/benefit": "getHomeInstitutionBenefitList",
  "get:/wello/v2/allows/home/institution/{homeLoveGovCode}/benefit/all": "getHomeInstitutionBenefitListAll",
  "get:/wello/v2/allows/home/institution/{homeLoveGovCode}/benefit/all/public": "getHomeInstitutionBenefitPublicList",
  "get:/wello/v2/allows/home/institution/{homeLoveGovCode}/benefit/all/private": "getHomeInstitutionBenefitPrivateList",
  "get:/wello/v2/allows/home/institution/policy": "getHomeInstitutionPolicyList",
  "get:/wello/v2/allows/home/institution/for-search-filter": "getHomeInstitutionListForSearchFilter",
  "get:/wello/v2/allows/home/institution/code-to-id/{homeLoveGovCode}": "getHomeLoveGovCodeToId",
  "get:/wello/v2/allows/home/institution-event": "getHomeInstitutionEventList",
  "get:/wello/v2/allows/home/institution-event/{institutionEventId}": "getHomeInstitutionEvent",
  "get:/wello/v2/allows/home/institution-event/ordered": "getOrderedHomeInstitutionEventList",
  "get:/wello/v2/allows/home/institution-content": "getHomeInstitutionContentList",
  "get:/wello/v2/allows/home/institution-content/{institutionContentId}": "getHomeInstitutionContent",
  "get:/wello/v2/allows/home/gift-review": "getGiftOrderProductReviewList",
  "get:/wello/v2/allows/home/gift-review/{reviewId}": "getGiftOrderProductReview",
  "get:/wello/v2/allows/home/gift-review/photo": "getGiftOrderProductPhotoReviewListByProduct",
  "get:/wello/v2/allows/home/gift-product": "getGiftProductList1",
  "get:/wello/v2/allows/home/gift-product/{productNumber}": "getGiftProduct",
  "get:/wello/v2/allows/home/gift-product/{productNumber}/related": "getRelatedGiftProductList",
  "get:/wello/v2/allows/home/gift-product/search": "searchGiftProductList",
  "get:/wello/v2/allows/home/gift-product/search/total-count": "searchGiftProductListCount",
  "get:/wello/v2/allows/home/gift-product/search/contains": "searchGiftProductListByContains",
  "get:/wello/v2/allows/home/gift-product/related": "getInstitutionGiftProductList",
  "get:/wello/v2/allows/home/gift-product/popular": "getGiftProductPopularByInstitutionList",
  "get:/wello/v2/allows/home/gift-product/by-institution": "getGiftProductListByInstitution",
  "get:/wello/v2/allows/home/gift-product/block": "getGiftProductBlockList",
  "get:/wello/v2/allows/home/gift-product-seo/{productNumber}": "getGiftProductSeo",
  "get:/wello/v2/allows/home/gift-category/primary": "getPrimaryGiftCategoryList",
  "get:/wello/v2/allows/home/event/december/random-ticket-winner": "getDecemberRandomTicketWinnerList",
  "get:/wello/v2/allows/home/event/december/institution-event": "getDecemberInstitutionEventInfoList",
  "get:/wello/v2/allows/home/event/december/gift-product": "getDecemberEventGiftProductList",
  "get:/wello/v2/allows/home/event/december/benefit-amount": "getEventAmountInfo",
  "get:/wello/v2/allows/home/donation-business": "getDonationBusinessList",
  "get:/wello/v2/allows/home/donation-business/{donationBusinessId}": "getDonationBusiness",
  "get:/wello/v2/allows/home/donation-business/{donationBusinessId}/related": "getRelatedDonationBusiness",
  "get:/wello/v2/allows/home/donation-business/{donationBusinessId}/detail-count": "getDonationBusinessDetailCount",
  "get:/wello/v2/allows/home/donation-business/related": "getInstitutionRelatedDonationBusiness",
  "get:/wello/v2/allows/home/donation-business/institution/{institutionId}": "getHomeInstitutionDonationBusiness",
  "get:/wello/v2/allows/home/donation-business-comment": "getDonationBusinessCommentList",
  "get:/wello/v2/allows/home-search-keyword": "getAdminHomeSearchKeywordList",
  "get:/wello/v2/allows/home-popup-notice": "getHomePopupNotice",
  "get:/wello/v2/allows/home-notice": "getHomeNoticeList",
  "get:/wello/v2/allows/home-notice/{homeNoticeId}": "getHomeNotice",
  "get:/wello/v2/allows/home-love/main/recommended-institution": "getHomeLoveMainRecommendedInstitutionList",
  "get:/wello/v2/allows/home-love/main/recent-gift-products": "getRecentDonatedGiftItems",
  "get:/wello/v2/allows/home-love/main/photo-review": "getWeeklyBestGiftPhotoReviews",
  "get:/wello/v2/allows/home-love/main/institution-with-gift-product": "getHomeInstitutionWithGiftProductList",
  "get:/wello/v2/allows/home-love/main/institution-specialty": "getHomeLoveMainInstitutionSpecialtyList",
  "get:/wello/v2/allows/home-love/main/featured-donation-businesses": "getHomeLoveMainFeaturedDonationBusinessesList",
  "get:/wello/v2/allows/home-love/main/daily-pick": "getHomeLoveMainDailyPickList",
  "get:/wello/v2/allows/home-love/donation/complete": "callbackComplete",
  "get:/wello/v2/allows/home-inquiry": "getHomeInquiryList",
  "get:/wello/v2/allows/home-inquiry/{homeInquiryId}": "getHomeInquiry",
  "get:/wello/v2/allows/home-donation/statistics": "getHomeDonationStatisticsList",
  "get:/wello/v2/allows/home-donation/by-donation-business": "getHomeDonationHistoryByDonationBusinessList",
  "get:/wello/v2/allows/home-donation-guide/calculate": "calculateDonation",
  "get:/wello/v2/allows/home-donation-event": "getHomeDonationEvent",
  "get:/wello/v2/allows/home-donation-event/is-progressing": "isEventInProgress",
  "get:/wello/v2/allows/home-donation-event-history/reward/recent": "getRecentEventHistoryList",
  "get:/wello/v2/allows/home-donation-event-history/reward/recent/september": "getRecentEventHistoryListInSeptember",
  "get:/wello/v2/allows/home-donation-event-history/member-name": "getMemberNameByInviteCode",
  "get:/wello/v2/allows/home-donation-event-history/invitee-donation/top": "getTopDonationEventHistoryList",
  "get:/wello/v2/allows/home-donation-event-gift-box/opened/recent": "getRecentOpenedGiftBoxList",
  "get:/wello/v2/allows/home-donation-event-gift-box/invites/top/august-event": "getTopInviterListInAugust",
  "get:/wello/v2/allows/geocoding": "getNCloudGeocodingByCode",
  "get:/wello/v2/allows/exposition-link-url": "expositionLinkUrlList",
  "get:/wello/v2/allows/emergency-room": "getEmergencyRoomList",
  "get:/wello/v2/allows/emergency-room/{emergencyRoomId}": "getEmergencyRoom",
  "get:/wello/v2/allows/emergency-room/{emergencyRoomId}/live": "getEmergencyRoomLive",
  "get:/wello/v2/allows/emergency-room/region": "getEmergencyRoomRegionList",
  "get:/wello/v2/allows/emergency-room/count": "getEmergencyRoomListCount",
  "get:/wello/v2/allows/emergency-room/code": "getEmergencyRoomCodeList",
  "get:/wello/v2/allows/cs/notice": "noticeList1",
  "get:/wello/v2/allows/cs/notice/{noticeId}": "notice",
  "get:/wello/v2/allows/cs/faq": "faqList",
  "get:/wello/v2/allows/control-managements": "getControlManagements",
  "get:/wello/v2/allows/contents/situation": "situationList",
  "get:/wello/v2/allows/contents/situation/{situationId}": "getSituationPolicyList",
  "get:/wello/v2/allows/contents/pick": "welloPickList",
  "get:/wello/v2/allows/contents/pick/{welloPickId}": "welloPickPolicyList",
  "get:/wello/v2/allows/contents/best": "bestContentsList",
  "get:/wello/v2/allows/contents/best/{bestContentsIdIdx}": "getBestContents",
  "get:/wello/v2/allows/contents/best/popular": "getPopularBestContentsList",
  "get:/wello/v2/allows/contents/best/new": "getNewBestContentsList",
  "get:/wello/v2/allows/contents/best/feedback/{bestContentsId}": "bestContentsFeedback",
  "get:/wello/v2/allows/community/wello-news": "getCommunityWelloNewsList",
  "get:/wello/v2/allows/community/wello-news/{communityIdIdx}": "getCommunityWelloNews",
  "get:/wello/v2/allows/community/wello-news/feedback/{communityIdIdx}": "feedbackCommunityWelloNews",
  "get:/wello/v2/allows/community/latest": "getLatestCommunityList",
  "get:/wello/v2/allows/community/home/benefits-popular": "getBenefitsPopularList",
  "get:/wello/v2/allows/community/category/{communityCategoryId}/child": "getCommunityCategory",
  "get:/wello/v2/allows/community/category/subcategory": "getCommunitySubcategoryListByCode",
  "get:/wello/v2/allows/community/category/main-category": "getCommunityMainCategoryList",
  "get:/wello/v2/allows/community/banner": "getCommunityBannerList",
  "get:/wello/v2/allows/card": "cardList",
  "get:/wello/v2/allows/banner": "bannerList",
  "get:/wello/v2/allows/bank": "bankList",
  "get:/wello/v2/allows/avail-card": "availCardList",
  "get:/wello/v2/allows/api-theme": "getApiThemeList",
  "get:/wello/v2/allows/api-theme/{apiThemeId}": "getApiTheme",
  "get:/wello/v2/allows/api-theme/name": "getApiThemeNameList",
  "get:/wello/v2/allows/api-theme/keyword/name": "getApiThemeKeywordNameList",
  "get:/wello/v2/allows/api-product/name": "getApiProductNameList",
  "get:/wello/v2/allows/api-policy": "getApiPolicyList",
  "get:/wello/v2/allows/api-policy/name": "getApiPolicyNameList",
  "delete:/wello/v2/allows/member": "resignMember",
  "delete:/wello/v2/allows/kb-pay": "resignWelloWithKbPay"
} as const;
